<template #default>
    <form
        v-if="status.detail && !loading"
        @submit.prevent="propertyAssetTenantUUID ? requestUpdate() : requestCreate()"
    >
        <div class="row">
            <div class="col-md-12">
                <h6 class="font-weight-bold text-info mb-3">
                    <i class="mdi mdi-home-outline mr-1"></i>
                    Rental Information
                </h6>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Asset"
                    label-cols="4"
                    label-align="left"
                >
                    <multiselect
                        v-model="createForm.propertyAssetUuid"
                        track-by="value"
                        label="text"
                        :placeholder="'Select'"
                        :select-label="'Select'"
                        :selected-label="'Selected'"
                        :deselect-label="'Select'"
                        :options="propertyAssetDdl"
                        :searchable="true"
                        :allow-empty="false"
                        :class="[submitted && !$v.createForm.propertyAssetUuid.required ? 'border border-danger' : '']"
                    />
                    <div v-if="submitted && !$v.createForm.propertyAssetUuid.required" class="invalid-feedback d-block text-right">
                        {{ $t("message.requiredX", ["Asset"]) }}
                    </div>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Customer"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.customer"
                        :class="{ 'is-invalid': submitted && !$v.createForm.customer.required }"
                        autocomplete="off"
                    />
                    <b-form-invalid-feedback v-if="submitted && !$v.createForm.customer.required" class="text-right">
                        {{ $t("message.requiredX", ["Customer"]) }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Customer Contact"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.customerContact"
                        autocomplete="off"
                    />
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Rental Value PSF"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.rentalValuePsf"
                        :class="{ 'is-invalid': submitted && $v.createForm.rentalValuePsf.$error }"
                        autocomplete="off"
                    />
                    <div v-if="submitted && $v.createForm.$error" class="invalid-feedback text-right">
                        <span v-if="!$v.createForm.rentalValuePsf.decimal">{{ $t("message.invalidX", ["Rental Value PSF"]) }}</span>
                    </div>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Rental Value Total"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.rentalValueTotal"
                        :class="{ 'is-invalid': submitted && $v.createForm.rentalValueTotal.$error }"
                        autocomplete="off"
                    />
                    <div v-if="submitted && $v.createForm.$error" class="invalid-feedback text-right">
                        <span v-if="!$v.createForm.rentalValueTotal.decimal">{{ $t("message.invalidX", ["Rental Value Total"]) }}</span>
                    </div>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Rental Size"
                    label-cols="4"
                    label-align="left"
                >
                    <div class="row">
                        <div class="col-md-6 mb-1">
                            <b-form-input
                                v-model.trim="createForm.rentalSize"
                                :class="{ 'is-invalid': submitted && $v.createForm.rentalSize.$error }"
                                autocomplete="off"
                            />
                            <div v-if="submitted && $v.createForm.$error" class="invalid-feedback text-right">
                                <span v-if="!$v.createForm.rentalSize.decimal">{{ $t("message.invalidX", ["Rental Size"]) }}</span>
                            </div>
                        </div>
                        <div class="col-md-6 mb-1">
                            <multiselect
                                v-model="createForm.rentalSizeUnitUuid"
                                track-by="value"
                                label="text"
                                :placeholder="'Unit'"
                                :select-label="'Select'"
                                :selected-label="'Selected'"
                                :deselect-label="'Select'"
                                :options="propertyAreaUnitDdl"
                                :searchable="true"
                                :allow-empty="false"
                                class="cursor-pointer"
                            />
                        </div>
                    </div>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Rental Date"
                    label-cols="4"
                    label-align="left"
                >
                    <DatePicker
                        v-model="createForm.rentalDate"
                        placeholder="yyyy-mm-dd"
                        class="cursor-pointer"
                        :config="{
                            format: 'YYYY-MM-DD',
                            useCurrent: false,
                            icons: {
                                time: 'mdi mdi-clock-outline',
                                date: 'mdi mdi-calendar',
                                up: 'mdi mdi-chevron-up',
                                down: 'mdi mdi-chevron-down',
                                previous: 'mdi mdi-chevron-left',
                                next: 'mdi mdi-chevron-right',
                                today: 'mdi mdi-calendar-check',
                                clear: 'mdi mdi-delete-outline',
                                close: 'mdi mdi-close',
                            },
                        }"
                    />
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Reminder Date"
                    label-cols="4"
                    label-align="left"
                >
                    <DatePicker
                        v-model="createForm.reminderDate"
                        placeholder="yyyy-mm-dd"
                        class="cursor-pointer"
                        :config="{
                            format: 'YYYY-MM-DD',
                            useCurrent: false,
                            icons: {
                                time: 'mdi mdi-clock-outline',
                                date: 'mdi mdi-calendar',
                                up: 'mdi mdi-chevron-up',
                                down: 'mdi mdi-chevron-down',
                                previous: 'mdi mdi-chevron-left',
                                next: 'mdi mdi-chevron-right',
                                today: 'mdi mdi-calendar-check',
                                clear: 'mdi mdi-delete-outline',
                                close: 'mdi mdi-close',
                            },
                        }"
                    />
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    label="Need Reminder"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-checkbox
                        v-model="createForm.needReminder"
                        switch
                        class="mt-2"
                    />
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <b-form-group
                    :label="$t('label.remark')"
                    label-cols="2"
                    label-align="left"
                >
                    <b-form-textarea
                        v-model.trim="createForm.remark"
                    />
                </b-form-group>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ propertyAssetTenantUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import DatePicker from 'vue-bootstrap-datetimepicker';
import { required, decimal } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { propertyAssetTenantMethods, lookupMethods } from "@/state/api";
import { PROPERTY_ASSET_TENANT_MODULE } from "@/state/api/propertyAssetTenant.state";

export default {
    props: {
        propertyAssetTenantUUID: {
            type: String,
            required: false,
        },
        propertyAsset: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                propertyAssetUuid: { required },
                customer: { required },
                rentalValuePsf: { decimal },
                rentalValueTotal: { decimal },
                rentalSize: { decimal },
            },
        };
    },
    components: { Multiselect, DatePicker },
    async created() {
        await this.lookupPropertyAsset();
        await this.lookupPropertyAreaUnit();
        await this.getPropertyAssetTenantData();

        this.loading = false;
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
            loading: !!this.propertyAssetTenantUUID,
        };
    },
    methods: {
        ...propertyAssetTenantMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: null,
                propertyAssetUuid: null,
                customer: null,
                customerContact: null,
                rentalValuePsf: null,
                rentalValueTotal: null,
                rentalDate: null,
                rentalSize: null,
                rentalSizeUnitUuid: null,
                reminderDate: null,
                needReminder: false,
                remark: null,
            };
        },
        async getPropertyAssetTenantData() {
            if (this.propertyAssetTenantUUID) {
                await this.getPropertyAssetTenant({ uuid: this.propertyAssetTenantUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                propertyAssetUuid: this.data.property?.asset ? {
                                    value: this.data.property?.asset?.uuid,
                                    text: this.data.property?.asset?.fileId,
                                } : null,
                                customer: this.data.customer,
                                customerContact: this.data.customerContact,
                                rentalValuePsf: this.data.rentalValuePsf,
                                rentalValueTotal: this.data.rentalValueTotal,
                                rentalDate: this.data.rentalDate,
                                rentalSize: this.data.rentalSize,
                                rentalSizeUnitUuid: this.data.rentalSizeUnit ? {
                                    value: this.data.rentalSizeUnit.uuid,
                                    text: this.data.rentalSizeUnit.name,
                                } : null,
                                reminderDate: this.data.reminderDate,
                                needReminder: this.data.needReminder,
                                remark: this.data.remark,
                            };
                        }
                    });
            } else {
                this.setPropertyAssetValue();
            }
        },
        setPropertyAssetValue() {
            if (this.propertyAsset) {
                this.createForm.propertyAssetUuid = this.propertyAssetDdl.find((item) => item.value == this.propertyAsset) || null;
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    propertyAssetUuid: this.createForm.propertyAssetUuid?.value,
                    rentalSizeUnitUuid: this.createForm.rentalSizeUnitUuid?.value,
                    needReminder: this.createForm.needReminder ? 1 : 0,
                };
                this.createPropertyAssetTenant({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    propertyAssetUuid: this.createForm.propertyAssetUuid?.value,
                    rentalSizeUnitUuid: this.createForm.rentalSizeUnitUuid?.value,
                    needReminder: this.createForm.needReminder ? 1 : 0,
                };
                this.updatePropertyAssetTenant({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(PROPERTY_ASSET_TENANT_MODULE, ['status']),
        data() {
            return this.$store.state.api.propertyAssetTenant.details;
        },
        propertyAssetDdl() {
            return this.$store.state.api.lookup.propertyAssetDdl || [];
        },
        propertyAreaUnitDdl() {
            return this.$store.state.api.lookup.propertyAreaUnitDdl || [];
        },
    },
}
</script>
